import axios from "../../axios";
import { Commit, Dispatch } from 'vuex'
import router from "@/router";

const baseURL = "/notifications";

export default ({
    namespaced: true,
    state: {
    },
    actions: {
        // async index({ commit }: { commit: Commit }, payload = {}) {
        //     const { data } = await axios.post(`${baseURL}`, payload);
        //     return data

        // },

        async index({ commit }: { commit: Commit }, payload = {}) {
            const { data } = await axios.get(`${baseURL}`, { params: { ...payload } });
            return data
        },

        async read({ dispatch }: { dispatch: Dispatch }, payload = { id: '' }) {
            const { data } = await axios.get(`${baseURL}/read/${payload.id}`);
            return data
        },



    },
    mutations: {
    },
    getters: {
    }
});




